import React from "react";
import { Input, Select } from "@components/form";
import { useFieldArray } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DaySchedule({
  dayIdx,
  dayId,
  methods,
  instructorList,
  dayFields,
  removeDay,
  readOnly=false,
}) {
  const { control, watch } = methods;
  const { fields: classFields, append, remove } = useFieldArray({
    control,
    name: `days.${dayIdx}.classes`,
  });

  const dateLabel = watch(`days.${dayIdx}.date`) || `Day ${dayIdx + 1}`;

  return (
    <div key={dayId}>


    <div className="page-title-wrap">
        <h2><span className="icon-squares"></span>{dateLabel}</h2>
        <div  style={{marginRight:'7px'}}>
            <div className="btn-right-box">
            <ul>
                <li>
                {!readOnly && ( 
                <button
                    type="button"
                    className="btn-add"
                    onClick={() =>
                    append({
                        classNo: classFields.length + 1,
                        subject: "",
                        startTm: "",
                        endTm: "",
                        instructorId: "",
                    })}
                >
                    추가
                </button>
                )}
                </li>
                <li>
                {/* 날짜 삭제 */}
                {!readOnly && dayFields.length > 1 && (
                    <button
                    type="button"
                    className="btn-delete"
                    onClick={() => removeDay(dayIdx)}
                    style={{ marginLeft: 8 }}
                    >
                    전체삭제
                    </button>
                )}
                </li>
            </ul>
            </div>
        </div>
    </div>    

      <table className="table-write schedule-table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "8%" }}>교시</th>
            <th>과목</th>
            <th style={{ width: "18%" }}>시작</th>
            <th style={{ width: "18%" }}>종료</th>
            <th style={{ width: "22%" }}>강사</th>
            {!readOnly &&<th style={{ width: "6%" }}>삭제</th>}
          </tr>
        </thead>
        <tbody>
          {classFields.map((c, cIdx) => (
            <tr key={c.id}>
              <td>
                {cIdx + 1}
                <input
                  type="hidden"
                  name={`days.${dayIdx}.classes.${cIdx}.classNo`}
                  value={cIdx + 1}
                />
              </td>
              <td>
                <Input name={`days.${dayIdx}.classes.${cIdx}.subject`} className="input-text" style={{ width: "100%" }} />
              </td>
              <td>
              <DatePicker
                selected={watch(`days.${dayIdx}.classes.${cIdx}.startTm`) || null}
                onChange={(time) => methods.setValue(`days.${dayIdx}.classes.${cIdx}.startTm`, time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="시작"
                dateFormat="HH:mm"
                placeholderText="시작시간"
                className="input-text"
                // filterTime={(time) => {
                //   const hour = time.getHours();
                //   return hour >= 8 && hour <= 20;
                // }}
              />
              </td>
              <td>
              <DatePicker
                selected={watch(`days.${dayIdx}.classes.${cIdx}.endTm`) || null}
                onChange={(time) => methods.setValue(`days.${dayIdx}.classes.${cIdx}.endTm`, time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={10}
                timeCaption="종료"
                dateFormat="HH:mm"
                placeholderText="종료시간"
                className="input-text"
                // filterTime={(time) => {
                //   const hour = time.getHours();
                //   return hour >= 8 && hour <= 20;
                // }}
              />
              </td>
              <td>
                <Select
                  name={`days.${dayIdx}.classes.${cIdx}.instructorId`}
                  className="input-select"
                  defaultOption="선택"
                  options={instructorList?.result}
                  valueKey="instructorId"
                  labelKey="instructorCombineName"
                  style={{ width: "100%" }}
                  disabled={readOnly}
                />
              </td>
              {!readOnly &&
              <td>

                <button type="button" className="btn-delete" style={{padding:"5px 15px"}} onClick={() => remove(cIdx)}>
                  삭제
                </button>
              </td>
              }
            </tr>
          ))}
          <br />
        </tbody>
      </table>


    </div>
  );
}
